// All editable site content lives here. Tweak strings as needed.
export const COMPANY = {
  name: "Crownpath Dispatch",
  legalName: "Crownpath Holdings LLC",
  shortName: "Crownpath",
  domain: "crownpathdispatch.com",
  phone: "(404) 954-2832",
  phoneHref: "tel:+14049542832",
  email: "dispatch@crownpathholdings.com",
  location: "Atlanta, Georgia",
  rate: "5% of gross",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services", id: "services" },
  { label: "How It Works", href: "#how-it-works", id: "how-it-works" },
  { label: "FAQ", href: "#faq", id: "faq" },
  { label: "Contact", href: "#contact", id: "contact" },
];

export const WHO_WE_WORK_WITH = [
  {
    title: "Owner-Operators",
    description:
      "Single-truck operators with their own authority who want a partner to handle the phones, the negotiation, and the paperwork.",
  },
  {
    title: "Small Fleets",
    description:
      "Two- to three-truck outfits ready to grow without hiring an in-house dispatcher or building a back office.",
  },
  {
    title: "New Authority Carriers",
    description:
      "Carriers fresh off MC approval who need a steady hand to navigate brokers, rate confirmations, and load boards from day one.",
  },
];

export const SERVICES = [
  {
    icon: "Search",
    title: "Load Sourcing",
    description:
      "We work DAT, Truckstop, and direct broker relationships to find loads that match your lanes, equipment, and rate targets.",
  },
  {
    icon: "Handshake",
    title: "Rate Negotiation",
    description:
      "Every load is negotiated for you. No more accepting the first number — we push for the rate the freight is worth.",
  },
  {
    icon: "FileText",
    title: "Paperwork & Rate Cons",
    description:
      "We handle rate confirmations, broker setup packets, carrier packets, and document collection start to finish.",
  },
  {
    icon: "ShieldCheck",
    title: "Broker Vetting",
    description:
      "We screen broker credit, payment history, and authority status before you ever roll a wheel for them.",
  },
  {
    icon: "Route",
    title: "Lane & Backhaul Planning",
    description:
      "Outbound and return loads planned together so your truck is loaded — not deadheading — when it matters.",
  },
  {
    icon: "Phone",
    title: "Direct Driver Support",
    description:
      "One number to call when something changes on the road. We handle the broker, you handle the truck.",
  },
];

export const STEPS = [
  {
    number: "01",
    title: "Onboarding",
    description:
      "We collect your MC, insurance, W-9, and lane preferences. Most carriers are fully onboarded in 24 hours.",
  },
  {
    number: "02",
    title: "We Dispatch",
    description:
      "We source loads, negotiate rates, and send you rate cons. You approve, you drive, you get paid.",
  },
  {
    number: "03",
    title: "You Get Paid",
    description:
      "We follow up on paperwork, POD submission, and broker payment so your invoices don't sit aging.",
  },
];

export const VALUE_PROPS = [
  {
    title: "Transparent 5% rate",
    description:
      "Flat 5% of gross — invoiced after you're paid. No hidden fees, no monthly minimums, no setup costs.",
  },
  {
    title: "No long-term contracts",
    description:
      "Month-to-month. If we don't earn it, you walk. We compete to keep your business every single load.",
  },
  {
    title: "Carrier-first negotiation",
    description:
      "Our incentive is your gross. Every dollar we win for you is a few more cents for us — interests aligned.",
  },
  {
    title: "Real human dispatchers",
    description:
      "You'll know your dispatcher by name. No call centers, no overseas teams, no script readers.",
  },
];

export const FAQS = [
  {
    q: "How much does it cost?",
    a: "Flat 5% of the gross revenue on every load we book for you. You pay nothing upfront, nothing monthly, and nothing if we don't book a load. Our fee is invoiced after the broker pays you.",
  },
  {
    q: "Do I need my own MC authority?",
    a: "Yes. Crownpath dispatches under your authority, not ours. If you're working on getting your MC, we're happy to point you to a few authority-setup partners we trust, then we'll be ready to dispatch the day you're active.",
  },
  {
    q: "What equipment types do you work?",
    a: "Dry van, reefer, flatbed, step deck, power-only, and hot shot. If you run something more specialized, ask us — there's a good chance we can build the lane.",
  },
  {
    q: "What lanes do you cover?",
    a: "All 48 contiguous states. We'll learn your preferred lanes, your home base, and your hours-of-service constraints during onboarding so dispatch fits your real life.",
  },
  {
    q: "How fast can I start?",
    a: "Most carriers are onboarded and dispatched within 24 hours of submitting their packet. We'll send you a clean checklist so nothing slows you down.",
  },
  {
    q: "Am I locked in?",
    a: "Never. Crownpath is month-to-month with no cancellation fee. You can pause or end the relationship any time. We'd rather earn your trust load by load than lock you in.",
  },
];

export const EQUIPMENT_TYPES = [
  "Dry Van",
  "Reefer",
  "Flatbed",
  "Step Deck",
  "Power Only",
  "Hot Shot",
  "Other",
];
